<!--
Author: TangChen
Date: 2018-11-21
Desc: 基金超市
 -->
<template>
    <div :class="'bizcomp-fund-market bizcomp ' + className">
        <comp-title :title="title" />
        <div class="fund-market">
            <el-row class="fund-filter">
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金类型：
                    <el-radio-group v-model="fundCate" size="mini">
                        <el-radio-button v-for="item in fundType" :key="item.val" :label="item.val">
                            {{ item.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金策略类型：
                    <el-radio-group v-model="strategyType" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="item in strategyTypeList"
                            :key="item.strategycode"
                            :label="item.strategycode"
                        >
                            {{ item.strategyname }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="fundRisk" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="risk in riskList"
                            :key="risk.subitem"
                            :label="risk.subitem"
                        >
                            {{ risk.subitemname }}风险
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="ismatch" size="mini">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1">只看风险匹配</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display: inline-block">
                        <el-tag
                            v-if="tag"
                            closable
                            :disable-transitions="false"
                            v-on:close="handleClose(tag)"
                        >
                            {{ tag }}
                        </el-tag>
                    </span>
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入查询基金名称或基金代码"
                        class="input-search"
                        :popper-append-to-body="false"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                    </el-autocomplete>
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="yellow"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
                <el-col :span="24" class="btn-fund">
                    共有
                    <span class="red">{{ allPage }}</span>
                    条基金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序：
                    <el-row v-model="sortVal" size="small" class="sort-btn">
                        <!--<el-button size="small" :type="sortVal==='sales'?'primary':''" @click="getVal('sales')">按销量<i :class="sort.sales?icond:iconu" aria-hidden="true"></i></el-button>-->
                        <el-button
                            size="small"
                            :type="sortVal === 'grow' ? 'yellow' : ''"
                            v-on:click="getVal('grow')"
                        >
                            按涨跌幅
                            <i aria-hidden="true" :class="sort.grow.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'incomeAll' ? 'yellow' : ''"
                            v-on:click="getVal('incomeAll')"
                        >
                            按成立以来收益
                            <i aria-hidden="true" :class="sort.incomeAll.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'income' ? 'yellow' : ''"
                            v-on:click="getVal('income')"
                        >
                            按今年以来收益
                            <i aria-hidden="true" :class="sort.income.up ? icond : iconu" />
                        </el-button>
                        <!--                        <el-button size="small" :type="sortVal==='risk'?'yellow':''" v-on:click="getVal('risk')">
                            按风险<i
                                :class="sort.risk.up?icond:iconu"
                            />
                        </el-button> -->
                        <el-select
                            v-show="sortVal ? sort[sortVal].id === 'dayfloatprofit' : false"
                            v-model="growValue"
                            class="grow-class"
                            size="small"
                            placeholder="请选择区间"
                        >
                            <el-option
                                v-for="item in growArea"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-row>
                </el-col>
            </el-row>
            <fund-risk-filter v-if="isPublic" :qryall="ismatch" v-on:qry-change="qryChange" />
            <fund-list
                :is-public="isPublic"
                :fund-info="fund"
                :fund-grow-qry="growValue"
                :all-page="allPage"
                v-on:new-fund="newFund"
                v-on:fund-continue="fundBuy"
            />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/fundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import fundApi from "@/api/fund";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter
    },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            fundCate: "", // 基金类型,默认全部类型
            fundRisk: "", // 基金风险
            ismatch: "0", // 是否只看风险匹配
            strategyType: "", // 基金策略类型
            strategyTypeList: [], // 策略类型数据
            searchText: "", // 搜索文本内容
            sortVal: "", // 排序字段
            lastSortVal: "", // 上次排序字段
            fund: [], // 基金信息
            dynamicTags: [], // 筛选条件
            queryFind: null, // 定时器
            qryallfund: "", // 适当性过滤字段
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            xjbCode: "", // 现金宝fundcodes
            riskList: [],
            url: "", // 当前页面路由命名
            isPublic: true, // 是否公募
            fundType: [
                { val: "", text: "全部" },
                { val: "04", text: "货币型" },
                { val: "01", text: "股票型" },
                { val: "03", text: "混合型" },
                { val: "02", text: "债券型" }
                // { val: "05", text: "指数型" }
                // { val: "4", text: "专户型" }
                // { val: "6", text: "QDII基金" }
            ],
            iconu: "el-icon-upload2",
            icond: "el-icon-download",
            sort: {
                incomeAll: {
                    id: "allud",
                    up: true
                },
                grow: {
                    id: "dayfloatprofit",
                    up: true
                },
                income: {
                    id: "thisyear1ud",
                    up: true
                },
                risk: {
                    id: "8",
                    up: false
                }
            },
            growArea: [
                {
                    value: "dayfloatprofit",
                    label: "日涨跌幅"
                },
                {
                    value: "month1ud",
                    label: "近一月涨跌幅"
                },
                {
                    value: "month3ud",
                    label: "近三月涨跌幅"
                },
                {
                    value: "month6ud",
                    label: "近六月涨跌幅"
                },
                {
                    value: "year1ud",
                    label: "近一年涨跌幅"
                },
                {
                    value: "year3ud",
                    label: "近三年涨跌幅"
                },
                {
                    value: "year5ud",
                    label: "近五年涨跌幅"
                },
                {
                    value: "allud",
                    label: "成立以来"
                }
            ],
            growValue: ""
        };
    },
    watch: {
        // 监测选项变化
        fundCate(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
                // const _x = this.fundType.find(risk => {
                //     return risk.val === from;
                // });
                // this.dynamicTags.splice(this.dynamicTags.indexOf(_x.text), 1);
            } else {
                const _x = this.fundType.find((risk) => {
                    return risk.val === val;
                });
                this.$set(this.dynamicTags, 0, _x.text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundRisk(val, from) {
            if (!val) {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === from;
                });
                this.dynamicTags.splice(this.dynamicTags.indexOf(_x.subitemname), 1);
            } else {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === val;
                });
                this.$set(this.dynamicTags, 1, _x.subitemname + "风险");
            }
            this.pageoffset = 1;
            this.doAction();
        },
        growValue(val) {
            if (val) {
                this.doAction();
            }
        },
        sortVal(val) {
            if (this.sort[val].id !== "dayfloatprofit") {
                this.growValue = "";
            }
        },
        strategyType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.strategyTypeList.find((strategy) => {
                    return strategy.strategycode == val;
                });
                this.$set(this.dynamicTags, 0, _x.strategyname);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        ismatch(val, from) {
            if (this.isPublic) {
                return;
            }
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const text = val == "0" ? "" : "只看风险匹配";
                this.$set(this.dynamicTags, 1, text);
            }
            this.pageoffset = 1;
            this.doAction();
        }
    },
    created() {
        this.$store.commit("updateLoadFund", false);
        this.url = this.$route.name;
        this.isPublic = this.$route.name == "fund" || this.$route.name == "glist";
        if (this.isPublic) {
            const info = this.$cache.getUser();
            if (info.professionflag == "0") {
                this.ismatch = info.ismatch || "1";
            }
            this.riskList = this.$cache.getDict("110143");
        } else {
            this.getFundStrategyType();
        }
        // this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.xjbCode = this.$cache.getXjbCode();
        this.doAction();
    },
    mounted() {
        this.getVal("grow");
    },
    methods: {
        // 获取排序数据
        getVal(val) {
            this.sortVal = val;
            if (this.sortVal === this.lastSortVal) {
                this.sort[val].up = !this.sort[val].up;
            } else {
                this.lastSortVal = this.sortVal;
            }
            this.doAction();
        },
        // 处理基金适当性信息
        fundBuy(way, val) {
            // 处理购买现金宝基金跳转
            if (this.xjbCode && this.xjbCode.indexOf(val.fundcode) > -1 && way === "20,22") {
                this.$router.push({ name: "currencycharge", query: { fundcode: val.fundcode } });
                return;
            }
            // 普通购买/定投
            let _url = "";
            if (way === "20,22") {
                _url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                _url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 搜索基金
        searchFund() {
            this.doAction(this.searchText);
        },
        // 获取策略类型数据
        async getFundStrategyType() {
            const res = await fundApi.getFundStrategyType();
            this.strategyTypeList = res.data || [];
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const _x = {
                fundtype: this.fundCate,
                strategylevel1: this.strategyType,
                risklevel: this.fundRisk,
                ismatch: this.ismatch,
                fundclass: this.isPublic ? "" : "1",
                smprodtype: "",
                orderfield: this.growValue
                    ? this.growValue
                    : this.sortVal
                    ? this.sort[this.sortVal].id
                    : "",
                isasc: this.sortVal ? (this.sort[this.sortVal].up ? "0" : "1") : "",
                valuagrbuystate: this.url === "glist" ? "1" : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                issale: this.isPublic ? "" : "1"
                // qrysmflag: "1"
            };
            const res = await fundApi.getFundLists(_x);
            if (res.data) {
                this.$store.commit("updateLoadFund", true);
                if (!cb) {
                    _this.fund = res.data.list;
                    if (_this.isPublic) {
                        // 记录过滤状态
                        const info = _this.$cache.getUser();
                        info.ismatch = _this.ismatch;
                        _this.$store.dispatch("setInfo", info);
                    }
                    _this.allPage = res.data.total.toString();
                } else {
                    cb.call(_this, res.data.list);
                }
            }
            // this.$util.request("trade/fund/list", _x, "GET", false).then(res => {
            //     if (res.data) {
            //         if (!cb) {
            //             _this.fund = res.data[0];
            //             _this.qryallfund = res.data[1][0].qryallfund;
            //             const info = _this.$cache.getUser();
            //             info.qryallfund = _this.qryallfund;
            //             _this.$store.dispatch("setInfo", info);
            //             _this.allPage = res.alllength;
            //         } else {
            //             cb.call(_this, res.data[0]);
            //         }
            //     }
            // });
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 搜索选项关闭处理
        handleClose(val) {
            if (this.isPublic) {
                if (val.toString().indexOf("风险") > -1) {
                    this.fundRisk = "";
                } else {
                    this.fundCate = "";
                }
            } else {
                if (val == "只看风险匹配") {
                    this.ismatch = "0";
                } else {
                    this.strategyType = "";
                }
            }
        }
    }
};
</script>

<style>
.my-autocomplete {
    width: auto !important;
}
</style>
